import { useQuery } from 'react-query';

export default () => {
  const { data, isSuccess } = useQuery(['GET', '/apis/v2/messages/inbox', { page: 1, per: 1 }]);
  const meta = data?.meta;
  const thread = (data?.data || [])[0];

  return { unreadCount: meta?.unreadCount, lastUpdatedThreadId: thread?.attributes?.conversationId, isSuccess };
};
